module.exports = __webpack_public_path__ + "static/media/Gotham-Medium.4cfe97f6.woff2";